export default "__VITE_ASSET__C4RXtr56__"